<ng-template class="light-dropdown" #al let-r="result" let-t="term">
  <span>{{ r.House }}, {{ r.Street }}, {{ r.PostCode }}</span>
  @if (r.isLoading) {
    <i class="button_spinner input_loading_spinner light-spinner"></i>
  }
</ng-template>
<ng-template #airlinesTemplate let-r="result" let-t="term">
  {{ r.name }}
</ng-template>
<ng-template #sl let-r="result" let-t="term">
  <div class="typeahead-result">
    <i class="ico-{{ r.type === LocationTypes.Airport ? 'flight' : 'rail' }}"></i>
    <span>&nbsp;{{ getList(r) }}</span>
  </div>
</ng-template>
<fieldset class="location-panel">
  <legend class="location-panel__title">
    {{ title }}&nbsp;
    @if (required) {
      <span class="light-color-warning">*</span>
    }
  </legend>
  <mat-radio-group [(ngModel)]="mode" class="radio-buttons-container">
    <mat-radio-button class="light-primary" color="primary" [value]="TaxiFormMode.ADDRESS">
      <span class="visuallyhidden">{{ title }} </span><span i18n="@@taxiAddressAddress">Address</span>
    </mat-radio-button>
    <div class="radio-button-wrapper flex-row-container align-items-end">
      <mat-radio-button class="light-primary" color="primary" [value]="TaxiFormMode.STATION">
        <span class="visuallyhidden">{{ title }} </span><span i18n="@@taxiAddressTrainAirport">Train St. / Airport</span>
      </mat-radio-button>
      <section (mouseleave)="tt.close()">
        <button
          #ttBtn
          type="button"
          class="accessible-tooltip-trigger ico ico-info-circle"
          ngbTooltip="If you require a Train Station outside of the UK, please perform an Address Search."
          i18n-ngbTooltip
          i18n-aria-label
          aria-label="Station search information"
          [attr.aria-describedby]="transformedTitle + '-station-outside-uk-tooltip'"
          placement="bottom"
          triggers="manual"
          #tt="ngbTooltip"
          (mouseenter)="tt.open()"
          (focus)="tt.open()"
          (blur)="tt.close()"
          (click)="tt.toggle()"
          (hidden)="
            ttBtn.setAttribute('aria-describedby', transformedTitle + '-station-outside-uk-tooltip')
          "
        ></button>
        <div
          class="visuallyhidden"
          [id]="transformedTitle + '-station-outside-uk-tooltip'"
          role="tooltip"
        >
          If you require a Train Station outside of the UK, please perform an Address Search.
        </div>
      </section>
    </div>
  </mat-radio-group>
  @if (mode === TaxiFormMode.ADDRESS) {
    <label
      id="{{ transformedTitle }}-taxi-address-pick-from-saved"
      class="header-label"
      for="{{ transformedTitle }}-address"
      i18n="@@taxiAddressPickFromSaved"
      >Pick from saved ({{ title }}):</label
    >
    <div class="flex-row-container savedAddressDiv">
      @if (loadingAddresses | async) {
        <i
          class="button_spinner input_loading_spinner_no_button light-spinner savedAddressButton"
        ></i>
      }
      <input
        readonly
        #inputAddress="ngbTypeahead"
        [inputFormatter]="formatAddresses"
        [ngbTypeahead]="getAddresses"
        autocomplete="off"
        type="text"
        id="{{ transformedTitle }}-address"
        i18n-placeholder
        placeholder="Select saved address"
        [resultTemplate]="al"
        (click)="$event.target.select()"
        name="travellingFrom"
        [(ngModel)]="address"
        (selectItem)="selectedAddress($event)"
        (focus)="updateAddress($event)"
        (click)="updateAddress($event)"
        [resultFormatter]="resultFormatBandListValue"
        appSelect
        [noIcon]="true"
        class="savedAddressInput"
        attr.aria-labelledby="{{ transformedTitle }}-taxi-address-pick-from-saved"
        (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
        (keyup.arrowup)="ensureElementIsScrolledTo($event)"
      />
    </div>
    <label
      id="{{ transformedTitle }}-taxi-address-house-no"
      class="header-label"
      i18n="@@taxiAddressNoName"
      for="{{ transformedTitle }}-taxihome"
      >{{ title }} House N°/Name*:</label
    >
    <input
      attr.aria-labelledby="{{ transformedTitle }}-taxi-address-house-no"
      appInput
      [noIcon]="true"
      #inputHouse
      required
      i18n-placeholder
      placeholder="Enter number or house name"
      id="{{ transformedTitle }}-taxihome"
      [(ngModel)]="address.House"
      (ngModelChange)="onChange($event)"
    />
    <label
      id="{{ transformedTitle }}-taxi-address-street"
      class="header-label"
      for="{{ transformedTitle }}-taxistreet"
      i18n="@@taxiAddressStreet"
      >{{ title }} Street:</label
    >
    <input
      attr.aria-labelledby="{{ transformedTitle }}-taxi-address-street"
      appInput
      [noIcon]="true"
      #inputStreet
      [required]="searchParams.vehicleType === CabHireVehicleType.Limo"
      i18n-placeholder
      id="{{ transformedTitle }}-taxistreet"
      placeholder="Enter street"
      [(ngModel)]="address.Street"
      (ngModelChange)="onChange($event)"
    />
    <label
      id="{{ transformedTitle }}-taxi-address-city"
      class="header-label"
      for="{{ transformedTitle }}-town"
      i18n="@@taxiAddressTownCity"
      >{{ title }} Town / City:
      @if (isGRS) {
        <span>*</span>
      }
    </label>
    <input
      attr.aria-labelledby="{{ transformedTitle }}-taxi-address-city"
      appInput
      [noIcon]="true"
      #inputTown
      id="{{ transformedTitle }}-town"
      i18n-placeholder
      placeholder="Enter town or city"
      [required]="isGRS"
      [(ngModel)]="address.Town"
      (ngModelChange)="onChange($event)"
    />
    <label
      id="{{ transformedTitle }}-taxi-address-county"
      class="header-label"
      for="{{ transformedTitle }}-county"
      i18n="@@taxiAddressCounty"
      >{{ title }} State / Province / County:
      @if (isGRS) {
        <span>*</span>
      }
    </label>
    <input
      attr.aria-labelledby="{{ transformedTitle }}-taxi-address-county"
      appInput
      [noIcon]="true"
      #inputCounty
      id="{{ transformedTitle }}-county"
      i18n-placeholder
      placeholder="Enter state, province or county"
      [required]="limo"
      [(ngModel)]="address.County"
      (ngModelChange)="onChange($event)"
    />
    <label
      id="{{ transformedTitle }}-taxi-address-postcode"
      class="header-label"
      for="{{ transformedTitle }}-postcode"
      i18n="@@taxiAddressPostCode"
      >{{ title }} Post code*:</label
    >
    <input
      attr.aria-labelledby="{{ transformedTitle }}-taxi-address-postcode"
      appInput
      [noIcon]="true"
      #inputPostCode
      required
      id="{{ transformedTitle }}-postcode"
      i18n-placeholder
      placeholder="Enter postcode"
      [(ngModel)]="address.PostCode"
      (ngModelChange)="onChange($event)"
    />
    <label
      id="{{ transformedTitle }}-taxi-address-country"
      class="header-label"
      for="{{ transformedTitle }}-country"
      i18n="@@taxiSearchCountry"
      >Country</label
    >
    <div class="flex-row-container">
      <i class="ico-marker select-box-icon"></i>
      <select
        [(ngModel)]="address.Country"
        attr.aria-labelledby="{{ transformedTitle }}-taxi-address-country"
        appSelect
        required
        (ngModelChange)="onChange($event)"
        id="{{ transformedTitle }}-country"
      >
        <option disabled value="null" i18n="@@carSearchSelectCountry">Select country</option>
        @for (country of searchService.countries; track country) {
          <option [ngValue]="country.cCode">
            {{ country.cName }}
          </option>
        }
      </select>
    </div>
    @if (limosCannotBeBooked) {
      <div i18n="@@LimosCannotBeBooked" class="pt-2">
        Unfortunately Limo's to this Country cannot be booked online. Please contact your travel
        team to book.
      </div>
    }
    <div class="action-buttons flex-row-container flex-row-container--tb-margin flex-column-mobile">
      <button
        id="{{ transformedTitle }}-taxi-clear-address-button"
        (click)="clearAddress()"
        appButton="small"
        class="small-button--reduced-text"
      >
        <span i18n="@@taxiAddressClear">Clear</span>
        <span class="visuallyhidden">{{ title }}</span>
        <span class="visuallyhidden" i18n="@@taxiAddressForm">Form</span>
      </button>
      <div class="flex-row-container flex-column-mobile">
        <button
          id="{{ transformedTitle }}-taxi-remove-address-button"
          (click)="openRemoveAddressesModal()"
          [disabled]="savingAddress"
          appButton="small"
          class="small-button--reduced-text small-button--flex margin-right-5"
        >
          @if (savingAddress) {
            <app-loading-spinner size="sm" />
          }
          @if (!savingAddress) {
            <span i18n="@@taxiAddressRemoveAddress">Remove Saved Addresses</span>
          }
          <span class="visuallyhidden">{{ title }}</span>
          <span class="visuallyhidden" i18n="@@taxiAddressForm">Form</span>
        </button>
        <button
          id="{{ transformedTitle }}-taxi-save-address-button"
          (click)="saveAddress()"
          [disabled]="!validAddress() || savingAddress"
          appButton="small"
          class="small-button--reduced-text small-button--flex"
        >
          @if (savingAddress) {
            <app-loading-spinner size="sm" />
          }
          @if (!savingAddress) {
            <span i18n="@@taxiAddressSaveAddress">Save Address</span>
          }
          <span class="visuallyhidden">{{ title }}</span>
          <span class="visuallyhidden" i18n="@@taxiAddressForm">Form</span>
        </button>
      </div>
    </div>
  } @else {
    <label
      class="header-label"
      for="{{ transformedTitle }}-station"
      id="{{ transformedTitle }}-taxi-address-choose-station"
      i18n="@@taxiAddressChooseStation"
      >Choose {{ title }} Station:</label
    >
    <div class="flex-row-container">
      <input
        #inputStation="ngbTypeahead"
        [inputFormatter]="formatStations"
        [resultTemplate]="sl"
        [ngbTypeahead]="getStations"
        autocomplete="off"
        type="text"
        id="{{ transformedTitle }}-station"
        i18n-placeholder
        placeholder="Select train station or airport"
        name="travellingFrom"
        container="body"
        placement="bottom-left"
        [(ngModel)]="station"
        (ngModelChange)="stationChange.emit(station); setAirportRail(station)"
        (focus)="updateStation($event)"
        (click)="updateStation($event)"
        appInput
        [noIcon]="true"
        class="button-box"
        attr.aria-labelledby="{{ transformedTitle }}-taxi-address-choose-station"
        [editable]="false"
        [required]="mode === TaxiFormMode.STATION"
        (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
        (keyup.arrowup)="ensureElementIsScrolledTo($event)"
      />
      @if (loadingStations | async) {
        <i class="button_spinner input_loading_spinner_no_button light-spinner"></i>
      }
    </div>
    <label
      id="{{ transformedTitle }}-taxi-address-county"
      class="header-label"
      for="{{ transformedTitle }}-county"
      i18n="@@taxiAddressCounty"
      >{{ title }} State / Province / County:
      @if (isGRS) {
        <span>*</span>
      }
    </label>
    <input
      attr.aria-labelledby="{{ transformedTitle }}-taxi-address-county"
      appInput
      [noIcon]="true"
      #inputCounty
      id="{{ transformedTitle }}-county"
      i18n-placeholder
      placeholder="Enter state, province or county"
      [required]="limo"
      [(ngModel)]="address.County"
      (ngModelChange)="onChange($event)"
    />
    <br />
    @if (
      address && ((type === LocationTypes.Airport && address.FlightNumber) || address.Terminal)
    ) {
      <div flex-row-container>
        <h2 style="color: white" i18n="@@taxiAddressFlightDetails">Flight Details</h2>
        <label
          class="header-label"
          i18n="@@taxiAddressChooseTerminal"
          for="{{ transformedTitle }}-terminal"
          >Terminal*</label
        >
        <select
          appInput
          [noIcon]="true"
          class="button-box"
          [value]="terminals[0].key"
          (change)="addTerminal($event.target.value)"
          id="{{ transformedTitle }}-terminal"
          required
        >
          @for (terminal of terminals; track terminal) {
            <option class="light-dropdown" [value]="terminal.key">
              {{ terminal.key | translate }}
            </option>
          }</select
        ><br />
        <div class="flight-info-container">
          <div class="flight-info-item">
            <label
              class="header-label"
              i18n="@@taxiAddressFlightNo"
              id="{{ transformedTitle }}-taxi-address-fligh-number"
              for="{{ transformedTitle }}-flightNo"
              >Flight Number</label
            >
            @if (searchParams.vehicleType === CabHireVehicleType.Limo) {
              <span>*</span>
            }
            <input
              type="text"
              [required]="searchParams.vehicleType === CabHireVehicleType.Limo"
              id="{{ transformedTitle }}-flightNo"
              [(ngModel)]="address.FlightNumber"
              (ngModelChange)="onChange($event)"
              attr.aria-labelledby="{{ transformedTitle }}-taxi-address-fligh-number"
              i18n-placeholder
              maxlength="10"
              placeholder="e.g. BA123"
              maxlength="10"
              appInput
              [noIcon]="true"
            />
          </div>
          @if (searchParams.vehicleType === CabHireVehicleType.Limo) {
            <div class="flight-info-item">
              <label
                class="header-label"
                id="{{ transformedTitle }}-taxi-flight-time"
                for="{{ transformedTitle }}-flightTime"
              >
                <span i18n="@@taxiFlight"> Flight </span>
                @if (title.includes('Pick')) {
                  <span i18n="@@taxiFlightArrival"> Arrival </span>
                }
                @if (title.includes('Drop')) {
                  <span i18n="@@taxiFlightDeparture"> Departure </span>
                }
                <span i18n="@@taxiFlightTime"> Time* </span>
              </label>
              <div class="flex-row-container">
                <i class="ico-clock combo-box-icon combo-box-icon--left" aria-hidden="true"></i>
                <select
                  required
                  id="{{ transformedTitle }}-flightTime"
                  appSelect
                  [(ngModel)]="address.FlightTrainDateTime"
                  attr.aria-labelledby="{{ transformedTitle }}-taxi-flight-time"
                  tabindex="0"
                >
                  @for (
                    time of getTimeArray(searchParams.time, title.includes('Drop'));
                    track time
                  ) {
                    <option [ngValue]="time">
                      {{ time }}
                    </option>
                  }
                </select>
              </div>
            </div>
          }
        </div>
        @if (searchParams.vehicleType === CabHireVehicleType.Limo) {
          <div>
            <label
              class="header-label"
              i18n="@@taxiAddressAirline"
              id="{{ transformedTitle }}-taxi-address-airline"
              for="{{ transformedTitle }}-Airline"
              >Airline*</label
            >
            <input
              autocomplete="off"
              [ngClass]="{ invalidAirline: invalidAirlineSelected }"
              required
              name="flight_airlines"
              i18n-placeholder
              placeholder="Select airline"
              container="body"
              placement="bottom-left"
              type="text"
              appInput
              [noIcon]="true"
              [(ngModel)]="carrier"
              [ngbTypeahead]="getAirline"
              [resultTemplate]="airlinesTemplate"
              [inputFormatter]="formatter_airlines"
              (focus)="updateAirline($event)"
              (click)="updateAirline($event)"
              (ngModelChange)="onChange($event)"
              attr.aria-labelledby="{{ transformedTitle }}-taxi-address-airline"
              id="{{ transformedTitle }}-Airline"
              (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
              (keyup.arrowup)="ensureElementIsScrolledTo($event)"
            />
            @if (invalidAirlineSelected) {
              <div class="error-message mt-2" i18n="@@taxiPleaseSelectAnAirline">
                Please select an airline from the list.
              </div>
            }
          </div>
        }
        <!-- <label class="header-label"
                                                                i18n="@@taxiAddressFlightTime"
                                                              for="{{ transformedTitle }}-flightTime">Time</label>
                                                              <input type="text"
                                                                id="{{ transformedTitle }}-flightTime"
                                                                [(ngModel)]="searchParams.time"
                                                                appInput [noIcon]="true" class="button-box" /><br> -->
      </div>
    }
    @if (
      type === LocationTypes.TrainStation && searchParams.vehicleType === CabHireVehicleType.Limo
    ) {
      <div flex-row-container>
        <h2 style="color: white" i18n="@@taxiAddressTrainDetails">Train Details</h2>
        <div class="train-details">
          <div class="train-operator-container">
            <label
              class="header-label"
              i18n="@@taxiATrainOperator"
              id="{{ transformedTitle }}-taxi-train-operator"
              for="{{ transformedTitle }}-trainOperator"
              >Train Operator*</label
            >
            <input
              attr.aria-labelledby="{{ transformedTitle }}-taxi-address-train-operator"
              appInput
              [noIcon]="true"
              required
              i18n-placeholder
              id="{{ transformedTitle }}-taxi-train-operator"
              placeholder="Select Train Operator"
              [(ngModel)]="carrier"
              (ngModelChange)="onChange($event)"
            />
          </div>
          <div class="train-time-container">
            <label
              class="header-label"
              id="{{ transformedTitle }}-taxi-address-train-time"
              for="{{ transformedTitle }}-TrainTime"
            >
              <span i18n="@@taxiTrain">Train</span>
              @switch (title) {
                @case ('Pick up') {
                  <span i18n="@@taxiFlightArrival"> Arrival </span>
                }
                @case ('Pickup Via') {
                  <span i18n="@@taxiFlightArrival"> Arrival </span>
                }
                @case ('Drop off') {
                  <span i18n="@@taxiFlightDeparture"> Departure </span>
                }
                @case ('Dropoff Via') {
                  <span i18n="@@taxiFlightDeparture"> Departure </span>
                }
              }
              <span i18n="@@taxiFlightTime"> Time* </span>
            </label>
            <div class="train-time-wrapper">
              <i class="ico-clock select-box-icon--left" aria-hidden="true"></i>
              <select
                required
                id="{{ transformedTitle }}-TrainTime"
                appSelect
                [(ngModel)]="address.FlightTrainDateTime"
                attr.aria-labelledby="{{ transformedTitle }}-taxi-address-train-time"
                tabindex="0"
              >
                @for (time of getTimeArray(searchParams.time, title.includes('Drop')); track time) {
                  <option [ngValue]="time">
                    {{ time }}
                  </option>
                }
              </select>
            </div>
          </div>
        </div>
      </div>
    }
  }
</fieldset>
